import { createContext, useContext, useMemo, useCallback } from "react";
import arDict from "@/i18n/ar.json";
import enDict from "@/i18n/en.json";

const dictionaries = { ar: arDict, en: enDict };

const TranslationContext = createContext({
  lang: "ar",
  t: (key) => key,
  dict: arDict,
});

export const TranslationProvider = ({ lang, children }) => {
  const safeLang = lang === "en" ? "en" : "ar";
  const dict = dictionaries[safeLang];

  const t = useCallback(
    (key, fallback) => {
      if (!key) return fallback ?? "";
      const parts = key.split(".");
      let cur = dict;
      for (const p of parts) {
        if (cur && typeof cur === "object" && p in cur) {
          cur = cur[p];
        } else {
          return fallback ?? key;
        }
      }
      return cur;
    },
    [dict]
  );

  const value = useMemo(() => ({ lang: safeLang, t, dict }), [safeLang, t, dict]);

  return (
    <TranslationContext.Provider value={value}>
      {children}
    </TranslationContext.Provider>
  );
};

export const useT = () => useContext(TranslationContext);
